module.exports = __webpack_public_path__ + "static/media/forgot-password.636bee0d.jpg";